{
  "nav.targets": "Targets",
  "targets.title": "Targets",
  "targets.description": "Each month's targets for sales, deals, calls and meetings, and how far along everyone is.",
  "targets.month.previous": "Previous month",
  "targets.month.next": "Next month",
  "targets.month.current": "This month",

  "targets.metric.sales_value": "Sales value",
  "targets.metric.deals": "Deals",
  "targets.metric.calls": "Calls",
  "targets.metric.meetings": "Meetings",
  "targets.metric.salesHint": "Closed deals' value",
  "targets.metric.dealsHint": "Leads moved to Closed deal",
  "targets.metric.callsHint": "Comments marked Call",
  "targets.metric.meetingsHint": "Meetings and viewings held",

  "targets.status.hit": "Target hit",
  "targets.status.onPace": "On pace",
  "targets.status.close": "Just behind pace",
  "targets.status.behind": "Behind pace",
  "targets.status.none": "No target",

  "targets.meter.label": "{percent} of target",
  "targets.meter.pace": "By now: {percent}",
  "targets.meter.paceLegend": "Where you should be by now",
  "targets.metric.ofTarget": "of {target}",
  "targets.metric.left": "{amount} to go",
  "targets.metric.done": "Done",
  "targets.metric.noTarget": "No target",
  "targets.overall": "Overall",
  "targets.byMetric": "By metric",
  "targets.overallHint": "The average across the metrics with a target",

  "targets.mine.title": "This month's target",
  "targets.team.title": "The team this month",
  "targets.company.title": "The company this month",
  "targets.mine.empty": "No target set for you this month yet.",
  "targets.team.empty": "No targets set this month yet.",
  "targets.open": "Open targets",
  "targets.pace": "{percent} of the month's working time gone",

  "targets.col.person": "Person",
  "targets.col.progress": "Progress",
  "targets.col.status": "Status",
  "targets.col.rank": "Rank",
  "targets.table.caption": "Targets and progress by person",
  "targets.empty.title": "Nobody to set targets for",
  "targets.empty.body": "Agents and team leaders appear here once they're added in Team.",

  "targets.set": "Set target",
  "targets.edit": "Edit target",
  "targets.editor.title": "{name}'s target",
  "targets.editor.description": "For {month}. Leave a metric empty for no target on it.",
  "targets.editor.save": "Save target",
  "targets.editor.clear": "Remove target",
  "targets.editor.saved": "Target saved for {name}.",
  "targets.bulk.open": "Set targets",
  "targets.bulk.title": "Set a target for several people",
  "targets.bulk.description": "For {month}. Everyone you pick gets these numbers; it replaces a target they already have this month. Leave a metric empty for no target on it.",
  "targets.bulk.who": "{count, plural, =0 {Who gets it} one {# person picked} other {# people picked}}",
  "targets.bulk.pick.agent": "All agents ({count})",
  "targets.bulk.pick.team_leader": "All team leaders ({count})",
  "targets.bulk.pick.all": "Everyone ({count})",
  "targets.bulk.none": "Clear",
  "targets.bulk.hasTarget": "Has a target",
  "targets.bulk.save": "{count, plural, =0 {Save target} one {Save for 1 person} other {Save for # people}}",
  "targets.bulk.saved": "{count, plural, one {Target saved for 1 person.} other {Target saved for # people.}}",
  "targets.copy": "Copy last month",
  "targets.copied": "{count, plural, =0 {Nothing to copy: everyone has a target or had none last month.} one {Copied # target from last month.} other {Copied # targets from last month.}}",

  "targets.leaderboard.title": "Leaderboard",
  "targets.leaderboard.caption": "Ranked by progress toward each person's own target",
  "targets.leaderboard.empty": "Rankings appear once targets are set.",

  "targets.tv.title": "Office TV",
  "targets.tv.body": "A live scoreboard for a screen in the office: this month's progress and the leaderboard. It opens without signing in, so anyone with the link can see it. It never shows clients, phones or deals.",
  "targets.tv.create": "Create link",
  "targets.tv.replace": "New link",
  "targets.tv.replaceHint": "The current link stops working.",
  "targets.tv.revoke": "Turn off",
  "targets.tv.active": "A link is live since {date}.",
  "targets.tv.inactive": "No link yet.",
  "targets.tv.copyLink": "Copy link",
  "targets.tv.copied": "Link copied.",
  "targets.tv.open": "Open",
  "targets.tv.once": "Copy it now: for safety it's shown only once.",
  "targets.tv.revoked": "The TV link is off.",
  "targets.tv.revokeTitle": "Turn off the TV link?",
  "targets.tv.revokeBody": "Screens showing it go dark until you create a new link.",

  "tv.title": "Scoreboard",
  "tv.month": "{month}",
  "tv.updated": "Updated {time}",
  "tv.invalid.title": "This screen link is off",
  "tv.invalid.body": "Ask an admin for the new link from Targets › Office TV.",
  "tv.offline": "Reconnecting…"
}
